import { queryPathBuilder } from '../../util/queryPathBuilder';
import {
  GET_ALL_SALES,
  REFUND_SALE,
  RESET_SANTANDER_PAYMENT_QUERY,
  SEND_SANTANDER_ID,
} from '../types';
import { get, post } from './Action';

const basePath = '/order';

export const getSales = (params) => async (dispatch) => {
  const queryParams = queryPathBuilder(params);
  return await dispatch(get(`${basePath}${queryParams}`, getSalesDS, true));
};

export const getOnlineSaleOrderDetail = (orderId) => async (dispatch) => {
  const response = await dispatch(
    get(`${basePath}/${orderId}/online-sale-detail`, null, true)
  );
  return response?.data;
};

export const getOnlineSaleTreatmentDetail =
  (orderId, purchasedProductId) => async (dispatch) => {
    const response = await dispatch(
      get(
        `${basePath}/${orderId}/treatment/${purchasedProductId}/detail`,
        null,
        true
      )
    );
    return response?.data;
  };

export const refundSale = (orderNumber, params) => async (dispatch) => {
  return await dispatch(
    post(`${basePath}/${orderNumber}/refund`, params, refundSaleDS)
  );
};

export const sendSantanderId = (data) => async (dispatch) => {
  const response = await dispatch(
    post(`${basePath}/send-santander-id`, data, sendSantanderIdDS, true)
  );

  return response?.data;
};

export const resetSantanderPaymentQuery = () => ({
  type: RESET_SANTANDER_PAYMENT_QUERY,
});

const getSalesDS = (sales) => ({
  type: GET_ALL_SALES,
  payload: sales.items,
});

const refundSaleDS = (sale) => ({
  type: REFUND_SALE,
  payload: sale,
});

const sendSantanderIdDS = (queryResult) => ({
  type: SEND_SANTANDER_ID,
  payload: queryResult,
});
